<template>
    <div class="row mt-2">
        <label for="facilities">Facilities</label>
        <button type="button" class="btn btn-link ml-auto" @click="addFacility()" title="Add Facility"><i class="fas fa-plus-square fa-lg"></i></button>
        <table id="facilities" class="table table-sm">
            <thead>
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Address</th>
                    <th scope="col">Phone Number</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <template v-if="facilities.length">
                    <tr v-for="facility in facilities" :key="facility.id">
                        <th scope="row">{{ facility.name }}</th>
                        <td>{{ facility.address }} {{ facility.city }}, {{ facility.state }} {{ facility.postal_code }}</td>
                        <td>{{ facility.phone_number | telephone }}</td>
                        <td>
                            <div class="float-right">
                                <button type="button" class="btn btn-link px-0" @click="editFacility(facility)"><i class="fas fa-edit fa-lg"></i></button>
                                <button type="button" class="btn btn-link px-0" @click="confirmDelete(facility.id)"><i class="fas fa-trash-alt fa-lg"></i></button>
                            </div>
                        </td>
                    </tr>
                </template>
                <template v-else>
                    <tr>
                        <td class="text-muted text-center pt-2" colspan="4"><h5>No facilities have been added.</h5></td>
                    </tr>
                </template>
            </tbody>
        </table>
        <facility-modal :states="this.states"></facility-modal>
        <delete-confirmation name="facility" @confirm="deleteFacility"></delete-confirmation>
    </div>
</template>

<script>
import FacilityModal from './FacilityComponent.vue';

export default {
    components: {
        FacilityModal
    },
    props: {
        npi: Number,
        states: Array
    },
    data() {
        return {
            facilities: []        
        }
    },
    methods: {
        refresh: function () {
            axios.get('/ajax/providers/' + this.npi + '/facilities')
                .then(response => {
                    this.facilities = response.data;
                })
                .catch(error => {
                    console.log('got an error...');
                });
        },
        addFacility: function () {
            eventHub.$emit('add-facility', this.npi);
        },
        editFacility: function (facility) {
            eventHub.$emit('edit-facility', facility);
        },
        confirmDelete: function (id) {
            eventHub.$emit('show-delete-facility-confirmation', id);
        },
        deleteFacility: function (id) {
            if (id) {
                axios.delete('/ajax/providers/' + this.npi + '/facilities/' + id)
                    .then(response => {
                        this.refresh();
                    })
                    .catch(error => {
                        let title = error.response.data.title;
                        let message = error.response.data.message;
                        let level = error.response.data.level;
                        toastr[level](message, title, {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
                    });
            }
        }
    },
    created() {
        this.refresh();
        eventHub.$on('facility-event', this.refresh);
    },
    beforeDestroy() {
        eventHub.$off('facility-event');
    }
}
</script>

<style scoped>
    label {
        padding-top: 0;
        padding-bottom: 0;
        vertical-align: bottom;
    }

    th, td {
        vertical-align: middle;
        padding-top: 0;
        padding-bottom: 0;        
    }
</style>